import React from 'react';
import styles from './Avatar.module.css';

const AVATARS = [
  { char: '🦊', bg: 'linear-gradient(135deg, #ff7675 0%, #ffeaa7 100%)' }, // Fox
  { char: '🐨', bg: 'linear-gradient(135deg, #74b9ff 0%, #a29bfe 100%)' }, // Koala
  { char: '🦁', bg: 'linear-gradient(135deg, #fdcb6e 0%, #e17055 100%)' }, // Lion
  { char: '🦄', bg: 'linear-gradient(135deg, #a29bfe 0%, #fd79a8 100%)' }, // Unicorn
  { char: '🐼', bg: 'linear-gradient(135deg, #dfe6e9 0%, #b2bec3 100%)' }, // Panda
  { char: '🐸', bg: 'linear-gradient(135deg, #55efc4 0%, #81ecec 100%)' }, // Frog
  { char: '🐯', bg: 'linear-gradient(135deg, #ffeaa7 0%, #fd9644 100%)' }, // Tiger
  { char: '🐙', bg: 'linear-gradient(135deg, #ff7675 0%, #fd79a8 100%)' }, // Octopus
  { char: '🐧', bg: 'linear-gradient(135deg, #81ecec 0%, #74b9ff 100%)' }, // Penguin
  { char: '🦉', bg: 'linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%)' }, // Owl
];

function getAvatarIndex(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % AVATARS.length;
}

export default function Avatar({ name = '?', avatarId, size = 36 }) {
  const index = typeof avatarId === 'number' ? avatarId : getAvatarIndex(name);
  const avatar = AVATARS[index % AVATARS.length] || AVATARS[0];
  const fontSize = Math.max(12, size * 0.55);

  return (
    <div
      className={styles.avatar}
      style={{
        width: size,
        height: size,
        background: avatar.bg,
        fontSize,
        minWidth: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        boxShadow: 'var(--shadow-sm)',
        lineHeight: 1,
      }}
      aria-hidden="true"
    >
      {avatar.char}
    </div>
  );
}
